import { useReducer, useContext, useEffect } from 'react';
import { CardContext } from './CardContext.js';

/**
 * An internal hook used to manage the Card's block link state.
 */
function useCardState() {
    function reducer(state, action) {
        if (action.type === 'register') {
            return {
                ...state,
                hasLink: true,
                linkRef: action.ref,
            };
        }
        if (action.type === 'unregister') {
            return {
                ...state,
                hasLink: false,
                linkRef: null,
            };
        }
        if (action.type === 'focus') {
            return {
                ...state,
                linkFocusState: true,
            };
        }
        if (action.type === 'blur') {
            return {
                ...state,
                linkFocusState: false,
            };
        }
        return state;
    }
    return useReducer(reducer, {
        hasLink: false,
        linkRef: null,
        linkFocusState: false,
    });
}
/**
 * An external hook used by individual Links to register to
 * a Card as a block link
 *
 * @param blockLink If link is a block link
 * @param ref Reference of the Link element
 * @returns Card context
 */
function useCard(blockLink, ref) {
    const context = useContext(CardContext);
    const { dispatch } = context !== null && context !== void 0 ? context : {};
    useEffect(() => {
        if (blockLink) {
            if (dispatch && ref && 'current' in ref) {
                dispatch({ type: 'register', ref });
            }
        }
        return () => {
            if (dispatch && ref && 'current' in ref) {
                dispatch({ type: 'unregister', ref });
            }
        };
    }, [dispatch, ref]);
    return context;
}

export { useCard, useCardState };
//# sourceMappingURL=hooks.js.map
